import { render, staticRenderFns } from "./trainOverview.vue?vue&type=template&id=58952d04&scoped=true&"
import script from "./trainOverview.vue?vue&type=script&lang=js&"
export * from "./trainOverview.vue?vue&type=script&lang=js&"
import style0 from "./trainOverview.vue?vue&type=style&index=0&id=58952d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58952d04",
  null
  
)

export default component.exports